export const accordionDetailsSx = {
  ml: 10,
  pb: 0,
};

export const accordionIconSx = {
  m: '0 8px',
};

export const accordionSx = {
  '&::before': { display: 'none' },
  '& .MuiAccordionSummary-root, & .MuiCollapse-entered': {
    borderBottom: '1px solid #F2F2F2',
  },
  '&.Mui-expanded': { m: 0 },
};

export const accordionSummarySx = {
  '& .MuiAccordionSummary-content': {
    alignItems: 'center',
    display: 'flex',
    m: 0,
  },
};

export const expandIconSx = (expanded: boolean) => ({
  mr: 1,
  transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
  transition: 'transform 0.3s',
});

export const dialogSx = {
  '& .MuiDialog-paper': {
    height: '90vh',
    maxHeight: '900px',
    maxWidth: '508px',
  },
  '& .MuiDialogContent-root': {
    paddingLeft: 0,
    paddingRight: 0,
  },
};

export const dialogTitleSx = {
  fontWeight: 600,
  p: 2,
  pb: 0,
};
